/**
 * Node healthcheck Tolerance in seconds.
 * @example When set to 30, it means that we consider a node healthy even when it's off-sync by roughly 3 blocks.
 */
const NODE_HEALTHCHECK_TOLERANCE_IN_SECONDS = 30;

export { NODE_HEALTHCHECK_TOLERANCE_IN_SECONDS };
